import React from "react";

import {Parts, Types} from "components";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Transactions_Collections_Object} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
export default class DispositionSignatures extends ObjectOverride {
	constructor(props) {
		super(props, Types.Signatures._name);
	}

	render() {
		return (
			<div>
				{this.props.transactionSignatures.length > 0 ? this.props.transactionSignatures.filter(signature => signature.signature !== '').map((signature, key) =>

					<Card key={key}>
						<CardContent style={{padding: '14px'}}>
							<Parts.DispositionSignatures signature={signature}/>
						</CardContent>
					</Card>
				) :
				this.props.signatures.filter(signature => signature.signature !== '').map((signature, key) =>
					<Card key={key}>
						<CardContent style={{padding: '14px'}}>
							<Parts.DispositionSignatures_v2 signature={signature}/>
						</CardContent>
					</Card>
				)}
			</div>
		)
	}
}
